import { reactive, readonly } from 'vue'

export const usePositiveNumber = (
  initialValue: number,
  isNotZero: boolean = false
) => {
  const state = reactive({
    value: initialValue
  })

  const handler: ProxyHandler<typeof state> = {
    get(target, prop) {
      return target[prop]
    },
    set(target, prop, value) {
      if (prop === 'value') {
        if (isNotZero) {
          if (value > 0 && typeof value === 'number') {
            target[prop] = value
          } else {
            target[prop] = initialValue
          }
        } else {
          if (value >= 0 && typeof value === 'number') {
            target[prop] = value
          } else {
            target[prop] = 0
          }
        }
      }
      return true
    }
  }

  return new Proxy(state, handler)
}
